import React from "react";

import RowWrapper from "../../shared/bootstrap/RowWrapper.jsx";
import HeaderSearch from "../../shared/HeaderSearch.jsx";

export default function Header({ searchType, setSearchType, searchValue, setSearchValue }) {
  return (
    <>
      <h1 className="page_title" role="banner" tabIndex="-1">
        NASA SEWP Contract Holders - Small Business
      </h1>
      <RowWrapper>
        <div className="col-sm-7" title="help text">
          <ul>
            <li>Select the Company Name to display the detailed information page for the specified Contract Holder.</li>
            <li>
              Select the column heading 'Company' to sort the table by company name - select it again to reverse the
              sort.
            </li>
            <li>
              Enter text in the search field to search within the table. Select from the radio buttons above the field
              to restrict your search. Select clear search to clear the search box.
            </li>
          </ul>
        </div>
        <HeaderSearch
          searchType={searchType}
          setSearchType={setSearchType}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
        />
      </RowWrapper>
    </>
  );
}
